// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const eventApi = baseApi.injectEndpoints({
  reducerPath: "eventApi",
  endpoints: (builder) => ({
    getAllEvents: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/events?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getEventDetails: builder.query({
        query: (id) => {
          return {
            url: `admin/events/${id}`,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        keepUnusedDataFor: 0,
        refetchOnFocus: true,
        // providesTags: ['User'],
      }),
    eventStatus: builder.mutation({
        query: (id) => {
          return {
            url: `admin/events/status/${id}`,
            method: "PUT",
            // body: data,
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        // invalidatesTags: ['User'],
      }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllEventsQuery,
  useGetEventDetailsQuery,
  useEventStatusMutation,
} = eventApi;
